import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ulid } from 'ulid';
import { AvailabilitySlot, AvailabilitySlotId, UnavailabilitySlot } from '../types/availability-interface';
import { groupAvailabilities } from '../utils';
type DraftUnavailabilitySlot = UnavailabilitySlot & {
  localId: string;
};
export const useDraftAvailabilitySlots = availabilitySlots => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [draftAvailabilitySlots, setDraftAvailabilitySlots] = useState(t0);
  const [initiated, setInitiated] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setInitiated(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reinitiate = t1;
  let t2;
  let t3;
  if ($[2] !== availabilitySlots || $[3] !== initiated) {
    t2 = () => {
      if (availabilitySlots && availabilitySlots.length > 0 && !initiated) {
        setDraftAvailabilitySlots(availabilitySlots);
        setInitiated(true);
      }
    };
    t3 = [availabilitySlots, initiated];
    $[2] = availabilitySlots;
    $[3] = initiated;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = slot => {
      setDraftAvailabilitySlots(prev => prev.map(prevDay => prevDay.id === slot.id ? slot : prevDay));
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const updateSlot = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = slotIds => {
      setDraftAvailabilitySlots(prev_0 => prev_0?.filter(prevDay_0 => !slotIds.includes(prevDay_0.id)));
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const removeSlots = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = slot_0 => {
      const id = ulid();
      setDraftAvailabilitySlots(prev_1 => prev_1 && [...prev_1, {
        ...slot_0,
        id
      }]);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const addSlot = t6;
  let t7;
  if ($[9] !== draftAvailabilitySlots) {
    t7 = groupAvailabilities(draftAvailabilitySlots);
    $[9] = draftAvailabilitySlots;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const {
    weekdaysSlots,
    dateSpecificSlots
  } = t7;
  let t8;
  if ($[11] !== dateSpecificSlots || $[12] !== draftAvailabilitySlots || $[13] !== weekdaysSlots) {
    t8 = {
      draftAvailabilitySlots,
      addSlot,
      removeSlots,
      updateSlot,
      weekdaysSlots,
      dateSpecificSlots,
      reinitiate
    };
    $[11] = dateSpecificSlots;
    $[12] = draftAvailabilitySlots;
    $[13] = weekdaysSlots;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export const useDraftUnavailabilitySlots = unavailabilitySlots => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [slots, setSlots] = useState(t0);
  const [initiated, setInitiated] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setInitiated(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reinitiate = t1;
  const withLocalId = _temp;
  let t2;
  let t3;
  if ($[2] !== initiated || $[3] !== unavailabilitySlots) {
    t2 = () => {
      if (unavailabilitySlots && unavailabilitySlots.length > 0 && !initiated) {
        setSlots(unavailabilitySlots.map(withLocalId));
        setInitiated(true);
      }
    };
    t3 = [unavailabilitySlots, initiated];
    $[2] = initiated;
    $[3] = unavailabilitySlots;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (slot_0, slotLocalId) => {
      setSlots(prev => prev.map(prevSlot => prevSlot.localId === slotLocalId ? {
        ...slot_0,
        localId: slotLocalId
      } : prevSlot));
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const updateSlot = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = slotLocalId_0 => {
      setSlots(prev_0 => prev_0?.filter(slot_1 => slot_1.localId !== slotLocalId_0));
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const removeSlot = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = slot_2 => {
      setSlots(prev_1 => prev_1 && [...prev_1, withLocalId(slot_2)]);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const addSlot = t6;
  let t7;
  if ($[9] !== slots) {
    t7 = {
      slots,
      addSlot,
      removeSlot,
      updateSlot,
      reinitiate
    };
    $[9] = slots;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
function _temp(slot) {
  return {
    ...slot,
    localId: ulid()
  };
}